<template>
    <CardWrap v-bind="$props" class="CardDefault">
        <div>This is a default render for unknown card type ({{ card.card_type_id }})</div>
    </CardWrap>
</template>

<script>
import CardBase from '@/views/Scenario/StepEditor/Card/component/CardBase'

export default {
    name: 'CardDefault',
    extends: CardBase
}
</script>
